module.exports = __webpack_public_path__ + "img/special_orbital.2cfb96c1.png";